export default {
  apiServerUrl: 'https://pet-fish.co.uk',
  googleMapsApiKey: ''
};
